


















import { defineComponent } from '@vue/composition-api';
import LearnMore from '~/components/atoms/LearnMore/LearnMore.vue';
import { useRouteExtended } from '~/composables';
import { DELIVERY_METHODS } from '~/constants/deliveryMethods';
import { ROUTES } from '~/constants/routes';
import ImgView from '~/components/atoms/ImgView/ImgView.vue';

export default defineComponent({
  name: 'DeliveryDetails',
  components: {
    LearnMore,
    ImgView,
  },
  setup() {
    const { getAdjustedSlug } = useRouteExtended();
    const deliveryLearnMoreUrl = getAdjustedSlug(ROUTES.DISPATCH_INFORMATION);
    const deliveryImgClasses = 'w-11.5 h-7.5 overflow-hidden object-contain';

    return { DELIVERY_METHODS, deliveryLearnMoreUrl, deliveryImgClasses };
  },
});
